import { j as t } from "../../../node_modules/react/jsx-runtime.js";
import { memo as I, useState as S, useEffect as v } from "react";
import { clsx as l } from "../../../node_modules/clsx/dist/clsx.m.js";
import C from "../../../node_modules/react-inlinesvg/dist/index.js";
import c from "./Icon.module.scss.js";
const y = "https://staticfiles.jisr.net/static-files-main/assets", e = /* @__PURE__ */ new Map(), H = ({
  name: o,
  size: n = "sm",
  className: h,
  styles: r,
  onClick: m,
  spin: d = !1,
  ...f
}) => {
  const [i, p] = S("");
  v(() => ((async () => {
    const s = o;
    if (!e.has(s)) {
      const g = `${y}/jisr/icons/${o}.svg`;
      e.set(s, g);
    }
    const w = e.get(s);
    p(w);
  })(), () => {
    const s = o;
    e.delete(s);
  }), [o]);
  const x = l(
    c.icon,
    c[n],
    r,
    d && c.spinner,
    h
  ), j = l(c.loader, c[n]), a = /* @__PURE__ */ t.jsx(
    "svg",
    {
      className: j,
      viewBox: "0 0 50 50",
      children: /* @__PURE__ */ t.jsx(
        "circle",
        {
          cx: "25",
          cy: "25",
          r: "10",
          fill: "none",
          strokeWidth: "4"
        }
      )
    }
  ), u = /* @__PURE__ */ t.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      height: "16",
      width: "16",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ t.jsx("path", { d: "M448 80c8.8 0 16 7.2 16 16V415.8l-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3V96c0-8.8 7.2-16 16-16H448zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z" })
    }
  );
  return i ? /* @__PURE__ */ t.jsx(
    C,
    {
      onClick: m,
      style: r,
      className: x,
      src: i,
      loader: a,
      ...f,
      children: u
    }
  ) : a;
}, M = I(H);
export {
  M as default
};
//# sourceMappingURL=Icon.js.map
